<template>
  <div class="waterno">
    <el-select
      style="width: 100%"
      v-model="inValue"
      placeholder="请选择用水编号"
      @change="change"
    >
      <el-option v-for="item in bindList" :key="item.id" :value="item.no">
        <div class="public-option-top">
          <span>{{ item.name }}</span>
          <span class="public-option-top-right">{{ item.no }}</span>
        </div>
        <div class="public-option-bottom">
          {{ item.address }}
        </div>
      </el-option>
      <div
        class="public-add-no"
        v-if="bindList.length < 3"
        @click="$router.push('/userbinding')"
      >
        <i class="el-icon-circle-plus-outline"></i>新增
      </div>
    </el-select>
    <el-tooltip
      v-if="noBind == true"
      effect="dark"
      content="填报此项目需先户号绑定"
      placement="right"
    >
      <el-button
        class="btn"
        type="success"
        plain
        @click="$router.push('/userbinding')"
        >绑定户号</el-button
      >
    </el-tooltip>
  </div>
</template>

<script>
import { GetBindList } from "@/api/search.js";
export default {
  data() {
    return {
      inValue: "",
      bindList: [],
      loading: false,
      noBind: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    //改变事件
    change(val) {
      let list = this.bindList;
      let index = list.findIndex((item) => {
        return item.no == val;
      });
      if (index != -1) {
        this.$emit("change", list[index]);
      } else {
        console.log("error");
      }
    },
    // //聚焦
    // focus() {
    //   // console.log(this.bindList);
    //   if (this.bindList.length == 0) {
    //     this.getList();
    //   } else {
    //     return false;
    //   }
    // },
    //获取options列表
    getList() {
      this.loading = true;
      GetBindList({})
        .then((res) => {
          //   console.log(res);
          this.bindList = res.data.data;
          if (res.data.data.length == 0) {
            this.noBind = true;
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  watch: {
    inValue: {
      handler(newVal) {
        this.$emit("select", newVal);
      },
      deep: true,
      immediate: true,
    },
    value: {
      handler(newVal) {
        if (this.bindList == undefined) {
          this.bindList = [];
        }
        if (newVal == "") {
          this.inValue = newVal;
        } else {
          if (this.bindList.length == 0) {
            if (newVal == this.inValue) {
              return false;
            }
            GetBindList({})
              .then((res) => {
                this.bindList = res.data.data.data;
                this.inValue = newVal;
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            this.inValue = newVal;
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  model: {
    event: "select",
    prop: "value",
  },
  props: {
    value: {
      type: [String, Number],
      default: "",
    },
  },
};
</script>

<style lang="less" scoped>
.waterno {
  display: flex;
  align-items: center;
  .btn {
    width: 100px;
    margin-left: 10px;
  }
}
</style>